module.exports = __webpack_public_path__ + "static/media/mypic.f2e12397.png";